import React from "react";
import ControlPanel from "./ControlPanel";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IControlBiolyt } from "./types";

interface IControlBiolytProps {
  control: IControlBiolyt;
}

const ControlBiolyt = (props: IControlBiolytProps) => {
  const { control } = props;
  const pelletsLevelPercent = useControlAttribute(
    control,
    "pellets_level_percent",
  );
  const mode = control.is_enabled ? "on" : "disabled";
  const iconColor = useModeColor(mode);
  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      state={pelletsLevelPercent + "%"}
    >
      <ToggleIconLink
        to={`/controls/details/${control.id}`}
        name="biolyt"
        color={iconColor}
      />
    </ControlPanel>
  );
};

export default ControlBiolyt;
